<div fxLayout="row" class="allergy-expanded">
  <div fxLayout="col" fxFlex="100" class="allergy-details">
    <nz-layout>
      <nz-header>{{"Details" | translate}}</nz-header>

      <nz-content>
        <!-- No. of comorbidities -->
        @if (item.noComorbidities) {
          <div fxLayout="row" class="detail-row">
            <div fxLayout="col" fxFlex="50" class="detail-label">{{'No. of comorbidities' | translate}}</div>
            <div fxLayout="col" fxFlex="50" class="detail-info">{{item.noComorbidities || "-"}}</div>
          </div>
        }

        <!-- Median (IQR) -->
        <!-- <div fxLayout="row" class="detail-row" *ngIf="item.iqr">
        <div fxLayout="col" fxFlex="50" class="detail-label">{{'Median (IQR)' | translate}}</div>
        <div fxLayout="col" fxFlex="50" class="detail-info">{{item.iqr || "-"}}</div>
      </div> -->

      <!-- Any comorbidity, n (%) -->
      @if (item.anyComorbidity) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'Any comorbidity, n (%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.anyComorbidity || "-"}}</div>
        </div>
      }

      <!-- Respiratory disease, n(%) -->
      @if (item.respiratoryDisease) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'Respiratory disease, n(%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.respiratoryDisease || "-"}}</div>
        </div>
      }

      <!-- Hypertension, n (%) -->
      @if (item.hypertension) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'Hypertension, n (%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.hypertension || "-"}}</div>
        </div>
      }

      <!-- COPD, n (%) -->
      @if (item.copd) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'COPD, n (%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.copd || "-"}}</div>
        </div>
      }

      <!-- Heart Disease, n(%) -->
      @if (item.heartDisease) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'Heart Disease, n(%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.heartDisease || "-"}}</div>
        </div>
      }

      <!-- Diabetes mellitus type II, n (%) -->
      @if (item.diabetesMellitus) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'Diabetes mellitus type II, n (%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.diabetesMellitus || "-"}}</div>
        </div>
      }

      <!-- Malignancy, n (%) -->
      @if (item.malignancy) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'Malignancy, n (%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.malignancy || "-"}}</div>
        </div>
      }

      <!-- Stroke, n (%) -->
      @if (item.stroke) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'Stroke, n (%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.stroke || "-"}}</div>
        </div>
      }

      <!-- Immunosuppression, n (%) -->
      @if (item.immunosuppression) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'Immunosuppression, n (%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.immunosuppression || "-"}}</div>
        </div>
      }

      <!-- No Comorbidities, n(%) -->
      @if (item.noComorbidities) {
        <div fxLayout="row" class="detail-row">
          <div fxLayout="col" fxFlex="50" class="detail-label">{{'No Comorbidities, n(%)' | translate}}</div>
          <div fxLayout="col" fxFlex="50" class="detail-info">{{item.noComorbidities || "-"}}</div>
        </div>
      }

    </nz-content>

  </nz-layout>
</div>
</div>
